<template>
	<SliderQ
		:maxNumSlides="6"
		:minSizeOfSlide="150"
    class="tag-partner"
	>
		 <slide
        	v-for="(item, index) in extrasSorted.filter(extra => weekSku.find(r => r === extra.id))"
        	v-if="!loading"
        >
	        <small-item-box			
				:itemTitle="item.title"
				:itemImage="item.images.small ? item.images.small : item.images.big"
			/>
        </slide>

        <slide
       		v-if="loading"
			v-for="i in 6"
		>
			<loading-placeholder
				class="shadow-box"
				:lines="2"
				:lineSize="10"
			/>
		</slide>
	</SliderQ>
</template>

<script>

import { ExtraApi } from '../../api/ExtraApi'
import { Extras } from '../../core/Extras'
import SmallItemBox from '../Parts/SmallItemBox'

import { menuStore } from '../../store/menuStore' 
import { configStore } from '../../store/configStore' 

export default {
	data () {
		return {
			extras: [],
			total: null,
			allSkuId: [],

			menuStore: menuStore.state,
			configStore: configStore.state
		}
	},

	components: {
		SmallItemBox
	},

	computed: {
		menu () {
			return this.menuStore.menu
		},

		loading () {
			return !(this.extras && this.extras.length > 0 && this.weekSku.length > 0)
		},

		weekSku () {
			if (!this.topEcommerce) return []
			return this.topEcommerce
					.concat(this.shuffledSku)
					.filter((it, i, ar) => ar.indexOf(it) === i)
					.slice(0, 6)
		},

		shuffledSku () {
			if (!this.menu) return []
			const seeder = () => {
				var seed_ = this.menu.id
				function rand () {
					var x = Math.sin(seed_++) * 10000
    				return x - Math.floor(x)
				}
				var seed = []
				return {
					set (length) {
						for (var i = 0; i < length; i++) {
							seed.push(rand())
						}
						return seed
					},
					get () {
						return seed
					},
					clear () {
						seed = []
					}
				}
			}

			if (!this.allSkuId) return 
			var seed = seeder()
			seed.set(this.allSkuId.length)

			return this.randomShuffle(this.allSkuId, seed.get())
		},

		topEcommerce () {
			return this.configStore.config && this.configStore.config['quomi.extras.slider_ecommerce']
				? this.configStore.config['quomi.extras.slider_ecommerce']
					.replace(/\s/g, '')
					.split(',')
					.map(r => +r)
					.filter(r => this.allSkuId.includes(+r))
				: this.configStore.default.slider_ecommerce
					.filter(r => this.allSkuId.includes(+r))
		},

		extrasSorted () {
			var extras = this.extras
			for (var i = this.weekSku.length - 1; i >= 0; i--) { 
	            var first = +this.weekSku[i] 
	            extras.sort((a, b) => a.id === first ? -1 : b.id === first ? 1 : 0) 
	        } 
			return extras.filter(extra => this.weekSku.find(r => r === extra.id))
		}
	},

	methods: {
		loadExtras () {
			var em = new ExtraApi()
			return em.all({
				params: {
					show: 60,
					page: 1,
					sort_direction: 'asc'
				}
			})

			.then(response => {
				response.body.data.resources.forEach(r => {
					if (r.tags.length > 0) this.allSkuId.push(r.id)
				})
				this.extras = new Extras(response.body.data.resources)
			})
		},

		randomShuffle (ar, seed) {
			var numbers = []
			for (var a = 0, max = ar.length; a < max; a++) {
				numbers.push(a)
			}
			var shuffled = []
			for (var i = 0, len = ar.length; i < len; i++) {
				var r = parseInt(seed[i] * (len - i))
				shuffled.push(ar[numbers[r]])
				numbers.splice(r, 1)
			}
			return shuffled
		}

	},

	mounted () {
		configStore.loadConfig()
		menuStore.loadCurrentMenu()
		this.loadExtras()
	}
}

</script>

<style scoped>


</style>
